export function parseEnvVariable(variable: string): unknown {
	try {
		return JSON.parse(variable);
	} catch (e: unknown) {
		return variable;
	}
}
